import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { TooltipProvider } from "@/components/ui/tooltip";
import { AuthProvider } from "@/contexts/AuthContext";

// Layouts
import { AdminLayout } from "./components/AdminLayout";

// Pages
import Login from "./pages/Login";
import AdminDashboard from "./pages/AdminDashboard";
import ItemList from "./pages/ItemList";
import ItemForm from "./pages/ItemForm";
import ShoesList from "./pages/ShoesList";
import HaulList from "./pages/HaulList";
import HaulForm from "./pages/HaulForm";
import Reports from "./pages/Reports";
import Settings from "./pages/Settings";
import NotFound from "./pages/NotFound";
import WeeklyPicksList from "./pages/WeeklyPicksList";
import MostViewedList from "./pages/MostViewedList";
import MostPopularList from "./pages/MostPopularList";
import QCSearchHistoryList from "./pages/QCSearchHistoryList";
import BackToSchoolList from "./pages/BackToSchoolList";
import BulkEdit from "./pages/BulkEdit";
import SellersList from "./pages/SellersList";
import OutfitsList from "./pages/OutfitsList";
import OutfitsDetail from "./pages/OutfitsDetail";
import UsersList from "./pages/UsersList";
import UserDetail from "./pages/UserDetail";
import StorageManager from "./pages/StorageManager";

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            {/* Public Routes */}
            <Route path="/login" element={<Login />} />
            
            {/* Redirect root to admin dashboard or login */}
            <Route path="/" element={<Navigate to="/admin" replace />} />
            
            {/* Protected Admin Routes */}
            <Route path="/admin" element={<AdminLayout />}>
              <Route index element={<AdminDashboard />} />
              <Route path="clothinglist" element={<ItemList />} />
              <Route path="clothinglist/new" element={<ItemForm />} />
              <Route path="clothinglist/:id" element={<ItemForm />} />
              <Route path="shoes" element={<ShoesList />} />
              <Route path="shoes/new" element={<ItemForm />} />
              <Route path="shoes/:id" element={<ItemForm />} />

              {/* Bulk Edit */}
              <Route path="bulk-edit" element={<BulkEdit />} />

              <Route path="hauls" element={<HaulList />} />
              <Route path="hauls/new" element={<HaulForm />} />
              <Route path="hauls/:id" element={<HaulForm />} />

              {/* Back 2 School Sale */}
              <Route path="back-2-school" element={<BackToSchoolList />} />

              {/* New: Outfits Management */}
              <Route path="outfits" element={<OutfitsList />} />
              <Route path="outfits/:id" element={<OutfitsDetail />} />

              {/* Sellers Management */}
              <Route path="sellers" element={<SellersList />} />

              {/* New: Users Management */}
              <Route path="users" element={<UsersList />} />
              <Route path="users/:id" element={<UserDetail />} />

              {/* New: Storage Management */}
              <Route path="storage" element={<StorageManager />} />

              <Route path="reports" element={<Reports />} />
              <Route path="weekly-picks" element={<WeeklyPicksList />} />
              <Route path="most-viewed" element={<MostViewedList />} />
              <Route path="most-popular" element={<MostPopularList />} />
              <Route path="qc-history" element={<QCSearchHistoryList />} />
              <Route path="settings" element={<Settings />} />
            </Route>
            
            {/* 404 Not Found */}
            <Route path="*" element={<NotFound />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;
